import { put, call } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as actions from '../actions/contract';
import { get, del, post, axiosPut } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getContractsByStock({ payload }) {
  try {
    const response = yield call(get,
      `/contract/list?plantId=${payload.plantId}`);
    yield put(actions.getContractsByStockSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getContractsByStockFail());
  }
}

export function* addContract({ payload }) {
  try {
    yield call(post, '/contract',
      {
        contractDate: payload.contractDate,
        contractNumId: 0,
        contractNumberLog: payload.contractNumberLog,
        contractNumberSys: payload.contractNumberSys,
        plant: payload.plantId
      });
    yield put(actions.addContractSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.addContractFail());
  }
}

export function* updateContract({ payload }) {
  try {
    yield call(axiosPut, '/contract', {
      contractDate: payload.contractDate,
      contractNumId: payload.contractNumId,
      contractNumberLog: payload.contractNumberLog,
      contractNumberSys: payload.contractNumberSys,
      plant: payload.plantId
    });
    yield put(actions.updateContractSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.updateContractFail());
  }
}

export function* deleteContract({ payload }) {
  try {
    yield call(del, `/contract?docNumId=${payload.docNumId}`);
    yield put(actions.deleteContractSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.deleteContractFail());
  }
}
